<template>
  <layout-vertical>

    <router-view />

    <!-- Above the content's <transition>, which renders only its first child -->
    <template #breadcrumb>
      <app-breadcrumb />
      <maintenance-banner />
    </template>

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import Navbar from '../components/Navbar.vue'
import MaintenanceBanner from '../components/MaintenanceBanner.vue'
import { initReviewNotifications, destroyReviewNotifications } from '@/services/reviews-notifications.service'

export default {
  components: {
    LayoutVertical,
    AppBreadcrumb,
    Navbar,
    MaintenanceBanner,
  },
  mounted() {
    initReviewNotifications(this.$router, this.$toast)
  },
  beforeDestroy() {
    destroyReviewNotifications()
  },
}
</script>
